/** @format */

import React from 'react';
import { Link } from 'react-router-dom';
import { API_URL } from 'src/constants';
import getRedirectionLink from 'src/utils/helper';

export function LinkWidget({ data }) {
  const image = API_URL + data.image;

  const handleLinkClick = e => {
    if (data.nid === 234) {
      e.preventDefault();
      setOpen(true);
    }
  };

  return (
    <div
      className={`link-widget ${data.highlight ? 'link-widget--highlight' : ''}`}
      data-width={data.w}
      data-height={data.h}
    >
      <div className="link-widget--list-item">
        <div className="link-widget--list-item-image">
          <img src={image} alt={data.title} />
          {data.category && <div className="link-widget--list-item-category">{data.category}</div>}
        </div>
        <div className="link-widget--list-item-title">{data.title}</div>
        <div className="link-widget--list-item-text">{data.content}</div>
        <div className="link-widget--list-item-link">
          {data.link ? (
            <a href={data.link} target={`${data.linkTarget === '_blank' ? '_blank' : ''}`}>
              {data.linkTitle}
            </a>
          ) : data.dashboardId ? (
            <Link to={`/dashboard/${data.dashboardId}`}>{data.linkTitle}</Link>
          ) : (
            <Link onClick={e => handleLinkClick(e)} to={getRedirectionLink(data)}>
              {data.linkTitle}
            </Link>
          )}
        </div>
      </div>
    </div>
  );
}
